/// <amd-module name="Test/TestCaseResults/Services/TestCaseResultsMenuService" />
import { TestCaseResultsActions, TestCaseResultsActionsTypes } from "Test/TestCaseResults/Redux/TestCaseResultsActions";
import { IRunDetailsItem } from "Test/TestCaseResults/Redux/TestCaseResultsContracts";

import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IResultsPageOpenMenu {
    runDetail: IRunDetailsItem;
    dispatch: any;
}

export interface ITestCaseResultsMenuService extends IVssService {
    openRunsHub(props: IResultsPageOpenMenu): void;
}

export class TestCaseResultsMenuService extends VssService implements ITestCaseResultsMenuService {
    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
    }

    public _serviceRestart(pageContext: IVssPageContext): void {
        super._serviceRestart(pageContext);
    }

    public openRunsHub(params: IResultsPageOpenMenu): void {
        params.dispatch(TestCaseResultsActions.openRunsHub(params.runDetail.pointId,params.runDetail.runId, params.runDetail.resultId ));
    }
}

Services.add("ITestCaseResultsMenuService", { serviceFactory: TestCaseResultsMenuService });
